import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { ROUTES } from '@common/constants';
import { AppContext } from '@context';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { getToken } = useContext(AppContext);
  const idToken = getToken();
  return (
    <Route
      {...rest}
      render={(props) =>
        !idToken ? <Redirect to={ROUTES?.LOGIN} /> : <Component {...props} />
      }
    />
  );
};
export default PrivateRoute;
